var map = {
	"./404.svg": "a14a",
	"./approve.svg": "7502",
	"./ask.svg": "335ce",
	"./bug.svg": "1779",
	"./chart.svg": "c829",
	"./clipboard.svg": "bc35",
	"./contract.svg": "eeeb",
	"./docType.svg": "d360",
	"./evaluation.svg": "2d13",
	"./exit-fullscreen.svg": "dbc7",
	"./eye-open.svg": "d7ec",
	"./eye.svg": "4df5",
	"./file.svg": "b8b2",
	"./finance.svg": "b599",
	"./form.svg": "eb1b",
	"./fullscreen.svg": "9921",
	"./goods.svg": "7421",
	"./guide.svg": "6683",
	"./home.svg": "6bbe",
	"./info.svg": "4be3",
	"./lock.svg": "ab00",
	"./message.svg": "47ff",
	"./money.svg": "3046",
	"./password.svg": "2a3d",
	"./qq.svg": "1430",
	"./questions.svg": "ff66",
	"./safety.svg": "6014",
	"./search.svg": "8e8d",
	"./service.svg": "4e04",
	"./set.svg": "9873",
	"./shopping.svg": "12a5",
	"./sign.svg": "2496",
	"./signature.svg": "3b22",
	"./star.svg": "708a",
	"./top.svg": "deee",
	"./train.svg": "1f54",
	"./tree.svg": "93cd",
	"./user.svg": "b3b5",
	"./verify.svg": "f9f0",
	"./weixin.svg": "5afe"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";